import type { ReactNode } from 'react';
import { Flex } from 'antd';
import styled from 'styled-components';
import { backgrounds } from '../../../theme-v2';

export interface ExperienceCanvasProps {
  children: ReactNode;
  className?: string;
}

/**
 * Full-page theme-v2 canvas — grey base, grain and a teal/indigo corner
 * glow (`theme-v2/backgrounds.ts`). Every experience-v2 page (viewer and
 * creator/edit) paints this as its own full-page background, so it's
 * shared here rather than duplicated per page.
 */
export const ExperienceCanvas = ({
  children,
  className,
}: ExperienceCanvasProps) => (
  <StyledRoot className={className}>{children}</StyledRoot>
);

const StyledRoot = styled(Flex).attrs({ vertical: true })`
  width: 100%;
  /* Fill the host's bounded area rather than forcing viewport height —
     consumers give this component a sized container (e.g. a 100vh,
     overflow-hidden host) so internal scrolling stays within it. */
  height: 100%;
  min-height: 0;
  overflow: hidden;
  ${backgrounds.canvas}
`;
